import { BulkImportCompletePage } from "@/features/learner/components/learner-bulk-import/BulkImportCompletePage";

const LearnerBulkImportComplete = () => {
  return <BulkImportCompletePage />;
};

export default LearnerBulkImportComplete;
